import React, {useState} from 'react'
import { RichText } from 'prismic-reactjs'
import { graphql } from 'gatsby';
import { ThemeProvider } from "styled-components"
import get from 'lodash/get';

import { standardiseInternalURL, getPathFromMeta, getAlternateLanguagePaths } from '../utils/link'

import Layout from '../components/layout'
import SEO from '../components/seo'

import SplitCover from '../components/split-cover'
import ComplexBody from '../components/complex-body'

import ConfigurationContext from '../context/configuration-context';
import PageMetaContext from '../context/page-meta-context';

import { THEME_WHITE } from '../theme/theme'

export const query = graphql`
	query HomeQuery($lang: String) {
		site {
			siteMetadata {
				siteUrl
				defaultLanguage
				includeDraftLanguages
			}
		}
		prismic{
			allConfigurations(lang:$lang){
				edges{
					node{
						_meta{
							lang
							uid
							type
						}

						flag
						language
						direction
						cyrillic
						
						site_name
						site_share_image
						site_title
						twitter_username

						label_author
						label_next
						label_previous
						label_of
						label_read_more
						label_view_all
						label_search
						placeholder_search
						headline_search
						label_search_results
						label_no_search_results
						label_show
						label_hide
						label_view_and_download
						label_archived_downloads

						months

						headline_404
						text_404
						headline_500
						text_500
					}
				}
			}
			allHomes(lang:$lang){
				edges{
					node{
						_meta{
							lang
							uid
							type
							firstPublicationDate
							lastPublicationDate
							alternateLanguages {
								uid
								type
								lang
								id
							}
						}
						page_title
						page_description
						page_share_image
						label
						headline
						cover_image
						cover_introduction
						cover_color
						cover_links
						body{
							... on PRISMIC_HomeBodyBlocks{
								type
								label
								primary{
									heading
								}
								fields {
									label
									heading
									text
									image
									color
									links
								}
							}
							... on PRISMIC_HomeBodyQuote{
								type
								label
								primary {
									quote
									image
									citation
									links
								}
							}
							... on PRISMIC_HomeBodyText_and_image {
								type
								label
								primary {
									label
									heading
									image
									image_color
									text
									reverse
									color
								}
								fields {
									icon
									text
								}
							}
							... on PRISMIC_HomeBodyPoints {
								type
								label
								primary {
									heading
									color
								}
								fields {
									icon
									label
								}
							}
							... on PRISMIC_HomeBodyPromo {
								type
								label
								primary {
									heading
									background
									background_color
									label
									links
								}
							}
							... on PRISMIC_HomeBodyAction {
								type
								label
								primary {
									heading
									links
									color
								}
							}
							... on PRISMIC_HomeBodyPromote_blog {
								type
								label
								primary {
									heading
									text
								}
								fields {
									article {
										... on PRISMIC_Article {
											_meta {
												firstPublicationDate
												lang
												uid
												type
											}
											headline
											introduction
											cover_image
											category {
												... on PRISMIC_Category {
													name
													_meta {
														uid
														type
														lang
													}
												}
											}
											
										}
									}
								}
							}

						}
					}
				}
			}
		}
	}
`

const HomePage = ({ data, location, pageContext }) => {
	const site = get(data,"site.siteMetadata");
	const page = get(data,"prismic.allHomes.edges[0].node");
	const configuration = get(data,"prismic.allConfigurations.edges[0].node");

	// check all relevant content exists
	if(!page || !configuration || !site) return null;

	// check actual path matches expected path
	// if(standardiseInternalURL(location.pathname) !== getPathFromMeta(page._meta)) return null;

	return(
		<ConfigurationContext.Provider value={configuration}>
			<PageMetaContext.Provider value={page._meta}>
				<ThemeProvider theme={{...THEME_WHITE,direction:configuration.direction,language:page._meta.lang,cyrillic:configuration.cyrillic}}>
					<Layout language={page._meta.lang} alternateLanguages={page._meta.alternateLanguages} meta={page._meta}>
						<SEO 
							includeDraftLanguages={site.includeDraftLanguages}
							siteURL={site.siteUrl}
							siteDirection={configuration.direction}
							siteName={configuration.site_name}
							siteTitle={configuration.site_title}
							siteShareImage={configuration.site_share_image}
							
							language={page._meta.lang}
							alternateLanguages={getAlternateLanguagePaths(page._meta.alternateLanguages)}

							twitterUsername={configuration.twitter_username} 
							
							pagePath={getPathFromMeta(page._meta)}
							pageSlug={page._meta.uid}
							pageType={page._meta.type}
							pageTitle={page.page_title}
							pageDescription={page.page_description}
							pageShareImage={page.page_share_image}
						/>
						<SplitCover color={page.cover_color} label={page.label} heading={page.headline} text={page.cover_introduction} links={page.cover_links} image={page.cover_image}  />
						<ComplexBody body={page.body} overlap={true} />
					</Layout>
				</ThemeProvider>
			</PageMetaContext.Provider>
		</ConfigurationContext.Provider>
	)
}

HomePage.query = query;

export default HomePage;